module.exports = __webpack_public_path__ + "media/images/page/photo_sample-m-5bcc2511190948f9cca57d4fd61fbec3.jpg";